import { Navigate, useLocation } from "react-router-dom";
import { Result, Spin } from "antd";
import { MeProvider, useMe } from "../../auth/MeContext";
import { requiredPermissionForPath, ROUTE_PERMISSIONS } from "../../auth/permissions";
import RoleManagement from "../setting/roles/RoleManagement";
import Sidebar from "../../components/sidebar/Sidebar";
import useAuth from "../../hooks/useAuth";
import { Component } from "../../utils/constants";
import AdminDetail from "../admin-detail";
import Category from "../category/Category";
import CategoryDetail from "../category/CategoryDetail";
import Coupon from "../coupon/Coupon";
import Dashboard from "../dashboard/Dashboard";
import HelpSupport from "../help-support/HelpSupport";
import HelpSupportDetail from "../help-support/HelpSupportDetail";
import HistoryLog from "../history-log/HistoryLog";
import Map from "../map/Map";
import Order from "../order/Order";
import OrderDetail from "../order/OrderDetail";
import OutletChangeRequestDetail from "../outlet-change-requests/OutletChangeRequestDetail";
import Notifications from "../notification/Notifications";
import OutletChangeRequests from "../outlet-change-requests/OutletChangeRequests";
import ManagerSalon from "../salon/ManagerSalon";
import AddSalon from "../salon/addSalon";
import EditRegistrationSalon from "../salon/editRegistrationSalon";
import EditSalon from "../salon/editSalon";
import Country from "../setting/country/Country";
import CancelReasons from "../setting/cancel-reason/CancelReasons";
import Language from "../setting/language/Language";
import MessageCodes from "../setting/message-code/MessageCodes";
import AppTranslation from "../setting/multi-lang/AppTranslation";
import SalonTranslation from "../setting/multi-lang/SalonTranslation";
import Package from "../setting/package/Package";
import PackageList from "../setting/package/PackageList";
import PackageForm from "../setting/package/PackageForm";
import PackageMenuConfig from "../setting/package/PackageMenuConfig";
import MenuList from "../setting/menu/MenuList";
import MenuForm from "../setting/menu/MenuForm";
import MenuReorder from "../setting/menu/MenuReorder";
import SystemConfig from "../setting/system-config/SystemConfig";
import SystemConfigs from "../setting/system-configs/SystemConfigs";
import LoyaltyPoints from "../setting/loyalty/LoyaltyPoints";
import AiChatSettings from "../setting/ai-chat/AiChatSettings";
import BillingFeeConfig from "../setting/billing/BillingFeeConfig";
import CancellationPolicyConfig from "../setting/billing/CancellationPolicyConfig";
import RefundRequests from "../setting/billing/RefundRequests";
import PaymentGatewayConfig from "../setting/billing/PaymentGatewayConfig";
import ExchangeRateConfig from "../setting/billing/ExchangeRateConfig";
import ReviewModeration from "../review-moderation/ReviewModeration";
import UserApp from "../user-app/UserAppp";
import { UserAppDetail } from "../user-app/UserAppDetail";
import UserAdmin from "../user/UserAdmin";
import "./Home.scss";

interface Props {
  component: string;
}
const HomeContent: React.FC<Props> = (props) => {
  const { pathname } = useLocation();
  const { can, loading, error } = useMe();

  const showComponent = () => {
    switch (props.component) {
      case Component.category:
        return <Category />;
      case Component.coupon:
        return <Coupon />;
      case Component.help_support:
        return <HelpSupport />;
      case Component.history_log:
        return <HistoryLog />;
      case Component.map:
        return <Map />;
      case Component.order:
        return <Order />;
      case Component.orderDetail:
        return <OrderDetail />;
      case Component.salon:
        return <ManagerSalon />;
      case Component.admin:
        return <UserAdmin />;
      // case Component.setting:
      //   return <Setting />;
      case Component.package:
        return <Package />;
      case Component.language:
        return <Language />;
      case Component.country:
        return <Country />;
      case Component.categoryDetail:
        return <CategoryDetail />;
      case Component.addSalon:
        return <AddSalon />;
      case Component.editSalon:
        return <EditSalon />;
      case Component.editRegistrationSalon:
        return <EditRegistrationSalon />;
      case Component.help_support_detail:
        return <HelpSupportDetail />;
      case Component.notifications:
        return <Notifications />;
      case Component.outlet_change_requests:
        return <OutletChangeRequests />;
      case Component.outlet_change_request_detail:
        return <OutletChangeRequestDetail />;
      case Component.adminDetail:
        return <AdminDetail />;
      case Component.userApp:
        return <UserApp />;
      case Component.userAppDetail:
        return <UserAppDetail />;
      case Component.appTranslation:
        return <AppTranslation />;
      case Component.salonTranslation:
        return <SalonTranslation />;
      case Component.systemConfig:
        return <SystemConfig />;
      case Component.loyalty:
        return <LoyaltyPoints />;
      case Component.aiChat:
        return <AiChatSettings />;
      case Component.billingFeeConfig:
        return <BillingFeeConfig />;
      case Component.cancellationPolicyConfig:
        return <CancellationPolicyConfig />;
      case Component.refundRequests:
        return <RefundRequests />;
      case Component.paymentGatewayConfig:
        return <PaymentGatewayConfig />;
      case Component.exchangeRateConfig:
        return <ExchangeRateConfig />;
      case Component.systemConfigs:
        return <SystemConfigs />;
      case Component.errorMessages:
        return <MessageCodes />;
      case Component.cancelReasons:
        return <CancelReasons />;
      case Component.packageList:
        return <PackageList />;
      case Component.packageCreate:
        return <PackageForm />;
      case Component.packageEdit:
        return <PackageForm />;
      case Component.packageMenuConfig:
        return <PackageMenuConfig />;
      case Component.menuList:
        return <MenuList />;
      case Component.menuCreate:
        return <MenuForm />;
      case Component.menuEdit:
        return <MenuForm />;
      case Component.menuReorder:
        return <MenuReorder />;
      case Component.reviewModeration:
        return <ReviewModeration />;
      case Component.roles:
        return <RoleManagement />;
      default:
        return <Dashboard />;
    }
  };
  if (loading) {
    return (
      <div className="home">
        <Spin size="large" style={{ margin: "30vh auto", display: "block" }} />
      </div>
    );
  }

  const needed = requiredPermissionForPath(pathname);
  const isRoot = pathname === "/" || pathname === "";
  const landing = ROUTE_PERMISSIONS.find((rule) => can(rule.permission));
  if (isRoot && !can("dashboard:read") && landing && !error) {
    return <Navigate to={landing.prefix} replace />;
  }

  return (
    <div className="home">
      <Sidebar>
        <div style={{ width: "100%" }}>
          {needed && !can(needed) ? (
            <Result
              status="403"
              title="403"
              subTitle="You do not have permission to access this page."
            />
          ) : (
            showComponent()
          )}
        </div>
      </Sidebar>
    </div>
  );
};

const Home: React.FC<Props> = (props) => {
  const { isLogin } = useAuth();
  return isLogin ? (
    <MeProvider>
      <HomeContent {...props} />
    </MeProvider>
  ) : (
    <Navigate to={"/login"} />
  );
};
export default Home;
